module.exports = __webpack_public_path__ + "img/visa.5df05eaf.svg";